import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule }   from '@angular/forms';
import { NgxGalleryModule } from 'ngx-gallery';
import { chatRouting } from './chat.routes';
import { ChatComponent } from './chat.component';
import { MitterService } from '../services/mitter.service';
import { ChannelComponent } from './components/channel/channel.component';
import { MessageComponent } from './components/message/message.component';
import { IncomingMessageAnchorComponent } from './components/icons/incoming-message-anchor/incoming-message-anchor.component';
import { OutgoingMessageAnchorComponent } from './components/icons/outgoing-message-anchor/outgoing-message-anchor.component';
import { SendIconComponent } from './components/icons/send-icon/send-icon.component';
import { SingleTickIconComponent } from './components/icons/single-tick-icon/single-tick-icon.component';
import { DoubleTickIconComponent } from './components/icons/double-tick-icon/double-tick-icon.component';
import { WaitingClockIconComponent } from './components/icons/waiting-clock-icon/waiting-clock-icon.component';
import { CameraIconComponent } from './components/icons/camera-icon/camera-icon.component';
import { FileIconComponent } from './components/icons/file-icon/file-icon.component';
import { ReceiptIconComponent } from './components/receipt-icon/receipt-icon.component';
import { MessagePayloadComponent } from './components/message-payload/message-payload.component';
import { ChatInputComponent } from './components/chat-input/chat-input.component';
import { ImageFormComponent } from './components/image-form/image-form.component';
import { BackIconComponent } from './components/icons/back-icon/back-icon.component';
import { ChannelListComponent } from './components/channel-list/channel-list.component';
import { PrescriptionOffIconComponent } from './components/icons/prescription-off-icon/prescription-off-icon.component';
import { PrescriptionOnIconComponent } from './components/icons/prescription-on-icon/prescription-on-icon.component';
import { VideoIconComponent } from './components/icons/video-icon/video-icon.component';
import { VideoChatComponent } from './components/video-chat/video-chat.component';
import { ChannelEventComponent } from './components/channel-event/channel-event.component';
import { AlertIconComponent } from './components/icons/alert-icon/alert-icon.component';
import { SharedModule } from '../common/shared.module';
import {NgxPaginationModule} from 'ngx-pagination';

@NgModule({
  imports: [
    CommonModule,
    chatRouting,
    FormsModule,
    NgxGalleryModule,
    SharedModule,
    NgxPaginationModule,
  ],
  declarations: [
    ChatComponent,
    ChannelComponent,
    MessageComponent,
    IncomingMessageAnchorComponent,
    OutgoingMessageAnchorComponent,
    SendIconComponent,
    SingleTickIconComponent,
    DoubleTickIconComponent,
    WaitingClockIconComponent,
    CameraIconComponent,
    FileIconComponent,
    ReceiptIconComponent,
    MessagePayloadComponent,
    ChatInputComponent,
    ImageFormComponent,
    BackIconComponent,
    ChannelListComponent,
    PrescriptionOffIconComponent,
    PrescriptionOnIconComponent,
    VideoIconComponent,
    VideoChatComponent,
    ChannelEventComponent,
    AlertIconComponent
  ]
})
export class ChatModule { }
